import fetch from '@/utils/fetch'

/**
 * 退出登录
 *
 * @export
 * @param {any} data
 * @returns
 */
export function logout(data) {
  return fetch({
    url: '/api_user/service/aw/mul/ow/account/logout',
    method: 'post',
    data: {}
  })
}

/**
 * 获取文章列表
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getArticleList(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/article/list',
    method: 'post',
    data
  })
}

/**
 * 获取文章详情
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getArticleDetail(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/article/get',
    method: 'post',
    data
  })
}

/**
 * 创建文章
 *
 * @export
 * @param {any} data
 * @returns
 */
export function addArticle(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/article/create',
    method: 'post',
    data
  })
}
/**
 * 编辑文章
 *
 * @export
 * @param {any} data
 * @returns
 */
export function editArticle(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/article/update',
    method: 'post',
    data
  })
}

/**
 * 更新文章数据状态
 *
 * @export
 * @param {any} data
 * @returns
 */
export function updateArticleStatus(data) {
  return fetch({
    url: '/api_zaiart/service/zaiart/article/update_status',
    method: 'post',
    data
  })
}

/**
 * 获取票号信息
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getTicketOrder(data) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/seller/ticket/order',
    method: 'post',
    data
  })
}

/**
 * 使用票号
 *
 * @export
 * @param {any} data
 * @returns
 */
export function useTicket(data) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/seller/ticket/use',
    method: 'post',
    data
  })
}

/**
 * 获取订单列表
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getOrderList(data) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/seller/order/list_by_param',
    method: 'post',
    data
  })
}
/**
 * 获取订单详情
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getOrderDetail(data) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/query',
    method: 'post',
    data
  })
}

/**
 * 获取快递公司列表
 *
 * @export
 * @returns
 */
export function getexpresslist(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/useraddress/getexpresslist',
    method: 'post',
    data
  })
}

/**
 * 发货
 *
 * @export
 * @returns
 */
export function orderShipment(data) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/seller/order/shipment',
    method: 'post',
    data
  })
}

/**
 * 获取账户余额
 *
 * @export
 * @returns
 */
export function getUserWallet(data = {}) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/auth/ofc/get_user_wallet',
    method: 'post',
    data
  })
}
/**
 * 销量列表
 *
 * @export
 * @returns
 */
export function getVolumeList(data) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/statistics/volume/list',
    method: 'post',
    data
  })
}
/**
 * 退款
 *
 * @export
 * @param {any} data
 * @returns
 */
export function orderRefund(data) {
  return fetch({
    url: '/api_order/service/aw/mul/ow/order/seller/refund',
    method: 'post',
    data
  })
}
/**
 * 商品列表
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getGoodList(data) {
  return fetch({
    url: '/api_cms/service/orga/good/list',
    method: 'post',
    data
  })
}
/**
 * 商品详情
 *
 * @export
 * @param {any} data
 * @returns
 */
export function getGoodInfo(data) {
  return fetch({
    url: '/api_cms/service/orga/good/detail',
    method: 'post',
    data
  })
}
/**
 * 导出excel报表
 *
 * @export
 * @param {any} data
 * @returns
 */
export function orderListToExcel(data) {
  return fetch({
    url: '/api_order/service/order/excel',
    method: 'post',
    data
  })
}
